import * as React from "react"
import styled from 'styled-components';
import { Seo } from "../../components/seo"
import Layout from "../../components/layout"
import SecurityComplianceHero from "../../components/security-compliance/pages-component/hero";
import SecurityComplianceCertificate from "../../components/security-compliance/pages-component/security-compliance-certificate";
import SecurityAndComplianceCard from "../../components/security-compliance/pages-component/security-compliance-card";
import CreateAAccount from "../../components/security-compliance/pages-component/create_a_account";


const StyledHome = styled("div")`

`

const SecurityAndCompliancePage = () => {
    return (
        <Layout>
            <StyledHome>
                <section className="py-3">
                    <SecurityComplianceHero />
                </section>
                <section className="py-3">
                    <SecurityComplianceCertificate />
                </section>
                <section className="py-3">
                    <SecurityAndComplianceCard />
                </section>
                <section className="py-3">
                    <CreateAAccount />
                </section>
            </StyledHome>
        </Layout>
    )
}

export default SecurityAndCompliancePage

export const Head = () => (
    <Seo
        title="Security & Compliance | Clearout"
        description="Clearout is ISO and SOC2 Type 2 Certified. We prioritize data protection and implement security checks, to maintain the trust of our valued users."
        pathname="security-compliance"
    />

)